var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "login" }, [
    _c(
      "div",
      { ref: "container", staticClass: "login-container" },
      [
        _c(
          "el-form",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            ref: "loginForm",
            staticClass: "login-container-form",
            attrs: {
              model: _vm.loginForm,
              rules: _vm.loginRules,
              "auto-complete": "on",
              "label-position": "left",
            },
          },
          [
            _c("p", { staticClass: "login-container-form-title" }, [
              _vm._v(_vm._s(_vm.projectName)),
            ]),
            _c(
              "el-form-item",
              {
                staticClass: "login-container-form-username",
                attrs: { prop: "username" },
              },
              [
                _c(
                  "el-input",
                  {
                    ref: "username",
                    staticClass: "login-container-form-username-input",
                    attrs: {
                      placeholder: "Username",
                      name: "username",
                      type: "text",
                      tabindex: "1",
                      "auto-complete": "on",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.handleLogin.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.loginForm.username,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.loginForm,
                          "username",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "loginForm.username",
                    },
                  },
                  [
                    _c("template", { slot: "prepend" }, [
                      _c(
                        "span",
                        { staticClass: "svg-container" },
                        [_c("svg-icon", { attrs: { "icon-class": "user" } })],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticClass: "login-container-form-password",
                attrs: { prop: "password" },
              },
              [
                _c(
                  "el-input",
                  {
                    key: _vm.passwordType,
                    ref: "password",
                    staticClass: "login-container-form-password-input",
                    attrs: {
                      type: _vm.passwordType,
                      placeholder: "Password",
                      name: "password",
                      tabindex: "2",
                      "auto-complete": "on",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.handleLogin.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.loginForm.password,
                      callback: function ($$v) {
                        _vm.$set(_vm.loginForm, "password", $$v)
                      },
                      expression: "loginForm.password",
                    },
                  },
                  [
                    _c("template", { slot: "prepend" }, [
                      _c(
                        "span",
                        { staticClass: "svg-container" },
                        [
                          _c("svg-icon", {
                            attrs: { "icon-class": "password" },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("template", { slot: "append" }, [
                      _c(
                        "span",
                        { staticClass: "show-pwd", on: { click: _vm.showPwd } },
                        [
                          _c("svg-icon", {
                            attrs: {
                              "icon-class":
                                _vm.passwordType === "password"
                                  ? "eye"
                                  : "eye-open",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticClass: "login-container-form-captcha",
                attrs: { prop: "captcha" },
              },
              [
                _c(
                  "el-input",
                  {
                    staticClass: "login-container-form-captcha-input",
                    attrs: { type: "text", placeholder: "验证码" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.handleLogin.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.loginForm.captcha,
                      callback: function ($$v) {
                        _vm.$set(_vm.loginForm, "captcha", $$v)
                      },
                      expression: "loginForm.captcha",
                    },
                  },
                  [
                    _c("template", { slot: "prepend" }, [
                      _c(
                        "span",
                        { staticClass: "svg-container" },
                        [
                          _c("svg-icon", {
                            attrs: { "icon-class": "component" },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("template", { slot: "append" }, [
                      _c("img", {
                        staticClass: "login-container-form-captcha-code",
                        attrs: { src: _vm.captchaImg },
                        on: {
                          click: function ($event) {
                            return _vm.refreshCaptcha()
                          },
                        },
                      }),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "el-button",
              {
                staticClass: "login-container-form-submit",
                attrs: { loading: _vm.loading, type: "primary" },
                nativeOn: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.handleLogin.apply(null, arguments)
                  },
                },
              },
              [_vm._v(" Login ")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }